import React, { useEffect, useState } from "react";
import ServiceIntellWidgets from "../../../services/KangarooServices/Intelligence/ServiceIntellWidgets";
import { useParams } from "react-router-dom";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import { Container, Row, Col, Card, CardBody, CardHeader } from "reactstrap";
import { imageBaseApi } from "../../../utilis/imageHelper";

const ServiceWidgetDetails = () => {
  const { id } = useParams();
  const [details, setDetails] = useState(null);

  const fetchDetails = async () => {
    try {
      const response = await ServiceIntellWidgets.getdetail(id);
      setDetails(response);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchDetails();
  }, [id]);

  const WidgetCard = ({ item }) => {
    return (
      <Card className="h-100 border-0 shadow-sm">
        {/* Image */}
        {item.image ? (
          <img
            src={`${imageBaseApi}${item.image?.url}`}
            alt={item.widgetName}
            className="img-fluid rounded-top"
            style={{ height: "200px", objectFit: "cover" }}
          />
        ) : (
          <div
            className="d-flex align-items-center justify-content-center bg-light rounded-top"
            style={{ height: "200px" }}
          >
            <i className="ri-image-line display-4 text-muted"></i>
          </div>
        )}

        <CardBody>
          {/* Destination */}
          <span className=" text-primary mb-2">
            {item.headingName}
          </span>

          {/* Widget Name */}
          <h5 className="fw-bold mb-2">{item.name}</h5>

          {/* Description */}
          <div
            className="content-html small text-muted"
            dangerouslySetInnerHTML={{
              __html: item.description,
            }}
          />
        </CardBody>
      </Card>
    );
  };
  return (
    <div className="page-content">
      <Container fluid>
        <BreadCrumb
          title="Service Widgets"
          pageTitle="Widget Details"
          breadcrumbItems={[
            { title: "Back to List", link: "/service-widgets" },
          ]}
        />
        <Row className="g-4">
          {details?.map((item) => (
            <Col lg={6} key={item.id}>
              <WidgetCard item={item} />
            </Col>
          ))}
        </Row>
      </Container>
    </div>
  );
};

export default ServiceWidgetDetails;
